module.exports = __webpack_public_path__ + "static/media/kontora-black.536ba82e.otf";